import clsx from "clsx";
import { debounce } from "lodash";
import { useRouter } from "next/router";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Api } from "@/api";
import Button from "~/components/common/button";
import Icon from "~/components/common/icon";
import ManagerInstallPrice from "~/components/pages/section/manager/installPrice";
import { showPopup } from "~/redux/action-creaters/popup";
import { declOfNum } from "~/utils";

import { fetchAllReviewsAndQuestions } from "../../../../redux/action-creaters/section";
import { SiteTypes } from "../../../../redux/reducers/paramsReducer";
import { popupTypes } from "../../../../redux/reducers/popupReducer";
import Breadcrumbs from "../../../common/breadcrumbs";
import Pagen from "../../../common/pagen";
import Banner from "../banner";
import Filter from "../filter";
import Product from "../product";
import Selector from "../selector";
import Tiles from "../tiles";
import styles from "./index.module.scss";

export default function SectionBody({ section = {} }: any) {
  const { products, count, params, meta, qestionsAndReviewsCount } =
    useSelector((state: any) => state.section);
  const { cityName, deliveyCity } = useSelector((state: any) => state.location);
  const [deliveryProductInfo, setDeliveryProductInfo]: any = useState({});
  const { params: filterParams } = useSelector((state: any) => state.filter);
  const [isShowMobileFilter, setShowMobileFilter] = useState(false);
  const { contactsData } = useSelector((state: any) => state.contacts);
  const { settings } = useSelector((state: any) => state.content);
  const { edostMinDays } = useSelector((state: any) => state.location);
  const { topMarks } = useSelector((state: any) => state.models);
  const { user } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const [managerDataNew, setManagerDataNew] = useState("");
  const [managerComments, setManagerComments] = useState([]);
  const [managerInstall, setManagerInstall] = useState([]);
  const [metaManagerComments, setMetaManagerComments] = useState([]);
  const [clientComments, setClientComments] = useState([]);
  const { siteType } = useSelector((state: any) => state.params);
  const { host } = useSelector((state: any) => state.params);
  const isBaltex = useMemo(() => {
    return siteType === SiteTypes.Baltex;
  }, [siteType]);
  const isFarkop = useMemo(() => {
    return siteType === SiteTypes.Farkop;
  }, [siteType]);

  useEffect(() => {
    if (cityName && edostMinDays) {
      if (contactsData.NAME === "Центральный") {
        const deliveryProductInfo: any = {};
        products.forEach((product: any) => {
          if (product.CATALOG.AVAILABLE) {
            deliveryProductInfo[product.ID] =
              `Доставка в г. ${cityName} от ${declOfNum(edostMinDays, ["дня", "дней", "дней"])}`;
          } else {
            // deliveryProductInfo[product.ID] = 'Нет в наличии'
          }
        });
        setDeliveryProductInfo(deliveryProductInfo);
      } else {
        setDeliveryProductInfo({});
      }
    }
  }, [cityName, edostMinDays, contactsData, products]);

  useEffect(() => {
    const body: any = document.querySelector("body");
    if (!isShowMobileFilter) {
      body.classList.remove("popup");
    } else {
      body.classList.add("popup");
    }
  }, [isShowMobileFilter]);

  const [scrollTop, setScrollTop] = useState(0);

  const selectedAuto = useMemo(() => {
    if (
      filterParams.marka?.[0] &&
      filterParams.model?.[0] &&
      filterParams.kuzov?.[0]
    ) {
      return true;
    }
    return false;
  }, [filterParams]);

  const isShowEmptyNotification = useMemo(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return (
      !selectedAuto &&
      !isShowMobileFilter &&
      ((window.innerWidth > 991 && scrollTop > 300) ||
        (window.innerWidth <= 991 && scrollTop > 200))
    );
  }, [scrollTop, selectedAuto, isShowMobileFilter]);

  const handleScroll = (e: any) => {
    setScrollTop(e.target.documentElement.scrollTop);
  };

  const debouncedScroll = debounce(handleScroll, 100);

  useEffect(() => {
    window.addEventListener("scroll", debouncedScroll);

    return () => {
      window.removeEventListener("scroll", debouncedScroll);
      debouncedScroll.cancel();
    };
  }, []);

  const router = useRouter();
  useEffect(() => {
    if (user.IS_MANAGER || user.IS_ADMIN || Boolean(router.query.demo)) {
      const ids = products.map((item: any) => item.ID);
      const getComments = async () => {
        setManagerComments(await Api.catalog.getManagerComments(ids));
      };
      const getManagerInstall = async () => {
        setManagerInstall(await Api.catalog.getManagerInstall(ids));
      };
      const getDataNew = async () => {
        setManagerDataNew(
          await Api.server.getManagerDelivery(
            ids,
            // @ts-ignore
            router.query.time,
            router.query.weekday,
          ),
        );
      };
      const getMetaComments = async () => {
        setMetaManagerComments(
          await Api.catalogSeo.getManagerComments(window.location.pathname),
        );
      };
      getComments();
      getDataNew();
      getMetaComments();
      getManagerInstall();
    }
  }, [user, products]);

  const { sections } = useSelector((state: any) => state.sections);

  useEffect(() => {
    // @ts-ignore
    (window as any).dataLayer = window.dataLayer || [];
    // @ts-ignore
    (dataLayer as any).push({
      ecommerce: {
        currencyCode: "RUB",
        impressions: products.map((product: any) => {
          return {
            id: product.ID,
            name: product.NAME,
            price: product.CATALOG?.MIN_PRICE,
            category: sections[product.IBLOCK_SECTION_ID].NAME,
            brand: product.BRAND?.name,
            list: "Каталог",
          };
        }),
      },
    });
  }, []);

  const stickyRef = useRef();

  const [lastScrollPos, setLastScrollPos] = useState(0);

  useEffect(() => {
    if (!stickyRef?.current) {
      return;
    }

    const diff = scrollTop - lastScrollPos;

    // @ts-ignore
    // eslint-disable-next-line operator-assignment
    stickyRef.current.scrollTop = stickyRef.current.scrollTop + diff;
    /* if (diff > 0) {
            console.log('1', stickyRef.current.scrollTop)
            stickyRef.current.scroll({
                top: stickyRef.current.scrollTop + diff,
                behavior: "smooth",
            });
        } else {
            console.log('2')
            stickyRef.current.scroll({
                top: stickyRef.current.scrollTop + diff,
                behavior: "smooth",
            });
        } */
    setLastScrollPos(scrollTop);
  }, [scrollTop]);

  const [viewType, setViewType] = useState(0);

  const [isShowTiles, setIsShowTiles] = useState(false);

  useEffect(() => {
    const isRobot =
      window.navigator?.userAgent?.includes("yandex") ||
      window.navigator?.userAgent?.includes("google");
    if (!isRobot) {
      setIsShowTiles(true);
    }
  }, []);

  useEffect(() => {
    const getClientComments = async () => {
      setClientComments(
        await Api.server.getClientComments(
          window.location.pathname,
          filterParams.marka?.[0],
          filterParams.model?.[0],
          filterParams.kuzov?.[0],
          window.location.host,
          Boolean(router.query.reset),
        ),
      );
    };
    getClientComments();
  }, [products]);

  useEffect(() => {
    dispatch(
      fetchAllReviewsAndQuestions(
        window.location.host.includes("localhost")
          ? "msk"
          : window.location.host.split(".")[0],
        products.map((item: any) => item.ID),
        Boolean(router.query.reset),
      ),
    );
  }, [products]);

  useEffect(() => {
    if (products.length === 0) {
      Api.server.addLogError(window.location.href, "errorsEmptyCatalog");
    }
  }, [products]);

  // @ts-ignore
  return (
    <div className="container">
      <Breadcrumbs />
      {isFarkop && <Banner cityName={deliveyCity} sectionId={section.ID} />}
      {isBaltex && (
        <h1 className={styles.BaltexH1}>{meta.h1 ?? section.NAME}</h1>
      )}
      <div className={styles.Content}>
        <div
          id="filter"
          className={clsx(
            styles.Side,
            isShowMobileFilter && styles.SideMobileVisible,
          )}
        >
          {settings.shopCatalogQuiz === "Y" && (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div
              className={styles.Assortment}
              onClick={() => {
                dispatch(showPopup(popupTypes.assortment));
              }}
            >
              <img src="/assortment.svg" />
            </div>
          )}
          {topMarks.length > 0 && isShowEmptyNotification && (
            <div className={styles.EmptyNotification}>
              <span>
                Не можете найти товар?
                <br />
                Выберите свой автомобиль!
              </span>
              <Button
                label="Выбрать"
                type="outlineWhite"
                onClick={async () => {
                  window.scrollTo({ top: 150, behavior: "smooth" });
                  const selector: any = document.getElementById("selector");

                  await new Promise((resolve) => {
                    setTimeout(() => {
                      selector.style.opacity = 0;
                      // @ts-ignore
                      resolve();
                    }, 500);
                  });
                  await new Promise((resolve) => {
                    setTimeout(() => {
                      selector.style.opacity = 1;
                      // @ts-ignore
                      resolve();
                    }, 200);
                  });
                  await new Promise((resolve) => {
                    setTimeout(() => {
                      selector.style.opacity = 0;
                      // @ts-ignore
                      resolve();
                    }, 200);
                  });
                  await new Promise((resolve) => {
                    setTimeout(() => {
                      selector.style.opacity = 1;
                      // @ts-ignore
                      resolve();
                    }, 200);
                  });
                }}
              />
            </div>
          )}
          {isShowMobileFilter && (
            <div className={styles.MobileFilterTitle}>
              <span>Все фильтры</span>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <span
                className={styles.Close}
                onClick={() => setShowMobileFilter(false)}
              >
                <Icon id="close" fill="#333" width={22} height={22} />
              </span>
            </div>
          )}

          <div
            className={styles.Sticky}
            // @ts-ignore
            ref={stickyRef}
          >
            {isFarkop && (
              <div id="selector" className={styles.Selector}>
                <Selector sectionPageUrl={section.SECTION_PAGE_URL} />
              </div>
            )}

            <Filter
              isBaltex={isBaltex}
              sectionPageUrl={section.SECTION_PAGE_URL}
              isShowMobileFilter={isShowMobileFilter}
            />
          </div>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={styles.SideMobileButton}
            onClick={() => setShowMobileFilter(true)}
          >
            <span>Все фильтры</span>
            <Icon id="filter" fill="#333" />
          </div>
        </div>
        <div className={styles.Block}>
          {isFarkop && (
            <h1>
              <span>{meta.h1 ?? section.NAME}</span>
              {host.replace("farkop-msk", "farkop") !== "farkop.ru" && (
                <span className={styles.h1City}>в {meta.titleCity}</span>
              )}
            </h1>
          )}
          {isBaltex && (
            <Selector
              sectionPageUrl={section.SECTION_PAGE_URL}
              isBaltex={isBaltex}
            />
          )}

          {meta.seoTop && (
            <div className="text">
              <div className={styles.SeoTop}>{meta.seoTop}</div>
            </div>
          )}
          {metaManagerComments?.length > 0 && (
            <div style={{ color: "red", marginBottom: "20px" }}>
              {metaManagerComments.map((comment: any) => (
                <div key={comment.NAME}>
                  {comment.NAME && <div>{comment.NAME}</div>}
                  {comment.TEXT && (
                    <div dangerouslySetInnerHTML={{ __html: comment.TEXT }} />
                  )}
                </div>
              ))}
            </div>
          )}
          {section.ID === "635" && (user.IS_MANAGER || user.IS_ADMIN) && (
            <ManagerInstallPrice />
          )}
          {isFarkop &&
            section.ID === "635" &&
            cityName &&
            !["Москва", "Санкт-Петербург"].includes(cityName) && (
              <div className={styles.FarkopBanner}>
                {cityName !== "Россия" && (
                  <span>
                    Быстрая доставка товаров в г.{cityName} проверенными
                    транспортными компаниями
                  </span>
                )}
                {cityName === "Россия" && (
                  <span>
                    Доставку осуществляем по всей территории России -{" "}
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span
                      className={styles.SelectCity}
                      onClick={() =>
                        dispatch(showPopup(popupTypes.locationNew))
                      }
                    >
                      выберите город
                    </span>
                  </span>
                )}
              </div>
            )}
          {!isBaltex && isShowTiles && !isShowMobileFilter && (
            <Tiles key={section.ID} sectionPageUrl={section.SECTION_PAGE_URL} />
          )}
          {(isFarkop || isBaltex) && clientComments?.length > 0 && (
            <div
              className={clsx(styles.Comment, isBaltex && styles.CommentBaltex)}
            >
              <div>
                {clientComments.map((comment: any) => (
                  <div key={comment.NAME}>
                    {comment.TEXT && <div>{comment.TEXT}</div>}
                  </div>
                ))}
              </div>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.99 22C6.46846 21.9945 1.99632 17.5149 2 11.9933C2.00368 6.47179 6.48179 1.99816 12.0033 2C17.5249 2.00184 22 6.47845 22 12C21.9967 17.5254 17.5154 22.0022 11.99 22ZM4 12.172C4.04732 16.5732 7.64111 20.1095 12.0425 20.086C16.444 20.0622 19.9995 16.4875 19.9995 12.086C19.9995 7.6845 16.444 4.10977 12.0425 4.08599C7.64111 4.06245 4.04732 7.59876 4 12V12.172ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                    fill="#FF4E52"
                  />
                </svg>
              </div>
            </div>
          )}
          {isFarkop && (
            <div className={styles.View}>
              <div>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span
                  className={clsx(viewType === 0 && styles.Selected)}
                  onClick={() => {
                    setViewType(0);
                  }}
                >
                  <Icon id="list" size={13} fill="#000" />
                </span>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span
                  className={clsx(viewType === 1 && styles.Selected)}
                  onClick={() => {
                    setViewType(1);
                    // @ts-ignore
                    if (typeof ym !== "undefined") {
                      // @ts-ignore
                      ym(20518312, "reachGoal", "changeCatalogViewToTable");
                    }
                  }}
                >
                  <Icon id="table" size={13} fill="#000" />
                </span>
              </div>
            </div>
          )}
          <div
            className={clsx(
              styles.Products,
              viewType === 1 && styles.ProductsTable,
            )}
          >
            {products.map((product: any) => (
              <Product
                isBaltex={isBaltex}
                viewType={viewType}
                data={product}
                key={product.ID}
                delivery={deliveryProductInfo[product.ID]}
                managerDataNew={managerDataNew[product.ID]}
                managerComment={managerComments[product.ID]}
                managerInstall={managerInstall[product.ID]}
                reviewsCount={qestionsAndReviewsCount[product.ID]?.REVIEWS || 0}
                questionsCount={
                  qestionsAndReviewsCount[product.ID]?.QUESTIONS || 0
                }
              />
            ))}
            {products.length === 0 && (
              <span className={styles.Empty}>
                По заданным фильтрам нет товаров.
              </span>
            )}
          </div>
          <div className={styles.Bottom}>
            <Pagen
              count={count}
              size={params.pageSize}
              currentNum={params.pageNum}
              isShowShowMore
            />
          </div>
          {meta.seoBottom && (
            <div className="text">
              <div
                className={styles.SeoBottom}
                dangerouslySetInnerHTML={{ __html: meta.seoBottom }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
